module.exports = __webpack_public_path__ + "img/Jbus01_R_home slider.63d092c7.jpg";